import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["Component"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { is } from 'immutable';
import { areEqual } from 'react-window';
import FoldableSectionTitle from 'flow/components/nav/list-items/FoldableSectionTitle';
import ListRowFrame from 'flow/components/nav/list-keys/ListRowFrame';
import { useStoreHoldsRow } from 'flow/components/nav/list-keys/row-index-store';
import useStableCallback from 'flow/hooks/useStableCallback';
import { rowIsFocusable } from './pbx-list-rows';
import { jsx as _jsx } from "react/jsx-runtime";
// Read when a row's menu opens. A row first renders before the list's
// elements are on the page, and it does not render again with the list.
var lockScroll = {
  get scroll() {
    return document.querySelector('.left-nav-scroll');
  },
  get wrapper() {
    return document.querySelector('.left-nav-scroll-wrapper');
  }
};
var PbxListItemContent = function PbxListItemContent(_ref) {
  var Component = _ref.Component,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(Component, _objectSpread({}, props));
};

// A refetch can write an item again, equal but new: RESULT_QUEUES does so for
// every queue. So the item counts as changed only when its value does. Every
// other prop keeps its identity while it says the same.
var itemContentPropsAreEqual = function itemContentPropsAreEqual(previous, next) {
  return is(previous.item, next.item) && Object.keys(next).every(function (prop) {
    return prop === 'item' || Object.is(previous[prop], next[prop]);
  });
};

// The item renders again only when one of its own props changes. A change to
// the list's rows, such as a new favourite, a folded section or a new search
// text, renders this row's frame again, and the frame stops here.
var MemoPbxListItemContent = /*#__PURE__*/React.memo(PbxListItemContent, itemContentPropsAreEqual);
var SectionTitle = /*#__PURE__*/React.memo(FoldableSectionTitle);
var PbxListItemRow = function PbxListItemRow(_ref2) {
  var index = _ref2.index,
    row = _ref2.row,
    data = _ref2.data;
  var isSelected = useStoreHoldsRow(data.selectionStore, data.rowKeys[index]);
  var Component = row.Component,
    key = row.key,
    item = row.item;
  var marking = data.selectionIsOpenPage ? 'pageOpen' : 'highlighted';
  // The list renders this row again whenever its index or the item data
  // change, so a click acts on the row where it is now, with its current
  // item, also after the list sorts again.
  var onClick = useStableCallback(function () {
    return data.onSelect(index, key, item);
  });
  return /*#__PURE__*/_jsx(MemoPbxListItemContent, {
    Component: Component,
    item: item,
    itemKey: key,
    marking: isSelected ? marking : undefined,
    enableCallButton: data.enableCallButton,
    onClick: onClick,
    lockScroll: lockScroll
  });
};
var RowContent = function RowContent(_ref3) {
  var index = _ref3.index,
    data = _ref3.data;
  var row = data.rows[index];
  switch (row.kind) {
    case 'sectionTitle':
      return /*#__PURE__*/_jsx(SectionTitle, {
        sectionId: row.department,
        title: row.title,
        isOpen: row.isOpen,
        canToggle: row.canToggle,
        onToggle: data.onToggleSection
      });
    case 'item':
      return /*#__PURE__*/_jsx(PbxListItemRow, {
        index: index,
        row: row,
        data: data
      });
    default:
      return null;
  }
};
var PbxListRow = function PbxListRow(_ref4) {
  var index = _ref4.index,
    style = _ref4.style,
    data = _ref4.data;
  return /*#__PURE__*/_jsx(ListRowFrame, {
    index: index,
    style: style,
    isFocusable: rowIsFocusable(data.rows[index]),
    tabStopStore: data.tabStopStore,
    tabStopKey: data.rowKeys[index],
    onUnmountWithFocus: data.onRowUnmountWithFocus,
    children: /*#__PURE__*/_jsx(RowContent, {
      index: index,
      data: data
    })
  });
};
export default /*#__PURE__*/React.memo(PbxListRow, areEqual);